import Phaser from 'phaser';
import { SCENE_KEYS } from '../config';

export class LevelCompleteScene extends Phaser.Scene {
  constructor() { super({ key: SCENE_KEYS.LEVEL_COMPLETE }); }

  create(data: { title?: string; text?: string; image?: string; briefingTitle?: string; briefingText?: string; briefingImage?: string }): void {
    const { width, height } = this.cameras.main;
    this.cameras.main.setBackgroundColor('#0a1a0a');

    const title = data.title || '¡NIVEL COMPLETADO!';
    const text = data.text || 'Has superado el desafío.';

    // Imagen placeholder
    if (data.image && this.textures.exists(data.image)) {
      const img = this.add.image(width / 2, height * 0.3, data.image);
      img.setDisplaySize(Math.min(width * 0.6, 400), Math.min(height * 0.35, 200));
      img.setOrigin(0.5);
    } else {
      // Estrella de victoria
      this.drawVictoryStar(width / 2, height * 0.28, 50);
    }

    // Título con glow
    const titleObj = this.add.text(width / 2, height * 0.12, title, {
      fontSize: '40px', fontFamily: 'Arial Black, Impact, sans-serif',
      color: '#ffcc00', stroke: '#000', strokeThickness: 4,
    }).setOrigin(0.5);
    this.tweens.add({ targets: titleObj, scaleX: 1.05, scaleY: 1.05, duration: 600, yoyo: true, repeat: -1 });

    // Texto con typewriter
    const bodyText = this.add.text(width / 2, height * 0.55, '', {
      fontSize: '18px', fontFamily: 'Arial, sans-serif',
      color: '#ffffff', lineSpacing: 8,
      wordWrap: { width: width * 0.7 }, align: 'center',
    }).setOrigin(0.5);

    let idx = 0;
    const typeTimer = this.time.addEvent({
      delay: 35,
      repeat: text.length - 1,
      callback: () => { idx++; bodyText.setText(text.substring(0, idx)); },
    });

    // Skip
    const skipBtn = this.add.text(width - 20, height - 20, 'SKIP ▶▶', {
      fontSize: '16px', fontFamily: 'monospace', color: '#888',
      backgroundColor: '#00000066', padding: { x: 8, y: 4 },
    }).setOrigin(1, 1).setDepth(10).setInteractive({ useHandCursor: true });

    const goNext = () => { this.scene.start(SCENE_KEYS.BRIEFING, { title: data.briefingTitle, text: data.briefingText, image: data.briefingImage }); };

    skipBtn.on('pointerdown', () => { typeTimer.remove(); bodyText.setText(text); goNext(); });
    this.input.keyboard?.on('keydown-ENTER', () => { typeTimer.remove(); goNext(); });
    this.input.keyboard?.on('keydown-SPACE', () => { typeTimer.remove(); goNext(); });
    this.input.on('pointerdown', (ptr: Phaser.Input.Pointer) => {
      if (!skipBtn.getBounds().contains(ptr.x, ptr.y) && idx >= text.length) goNext();
    });
  }

  private drawVictoryStar(cx: number, cy: number, r: number): void {
    const g = this.add.graphics();
    g.fillStyle(0xffcc00);
    g.beginPath();
    for (let i = 0; i < 5; i++) {
      const angle = (i * 4 * Math.PI) / 5 - Math.PI / 2;
      const x = cx + r * Math.cos(angle);
      const y = cy + r * Math.sin(angle);
      i === 0 ? g.moveTo(x, y) : g.lineTo(x, y);
    }
    g.closePath();
    g.fillPath();
    g.fillStyle(0xffee66, 0.4);
    g.fillCircle(cx, cy, r * 0.4);
  }
}
